import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import { Entity } from "./Entity"
import { HttpError, newHttpError } from "./Error"


class HttpClient<T extends Entity, D> {
    private Creator: new (dto: D) => T
    constructor(Creator: new (dto: D) => T) {
        this.Creator = Creator
    }

    async get(url: string): Promise<T | T[] | HttpError> {
        const res = await AppContext.getApiClient().get(url)
        if (Array.isArray(res.data)) {
            return res.data.map(e => new this.Creator(e as D))
        }
        const entity = new this.Creator(res as D)
        if (!entity.isLoaded()) {
            return newHttpError("Could not get entity", res)
        }
        return entity
    }

    async patch(url: string, payload: object): Promise<T | HttpError> {
        const res = await AppContext.getApiClient().patch(url, payload)
        const entity = new this.Creator(res as D)
        if (!entity.isLoaded()) {
            return newHttpError("Could not patch entity", res)
        }
        return entity
    }

    async put(url: string, payload: object): Promise<T | HttpError> {
        const res = await AppContext.getApiClient().put(url, payload)
        const entity = new this.Creator(res as D)
        if (!entity.isLoaded()) {
            return newHttpError("Could not patch entity", res)
        }
        return entity
    }

    async post(url: string, payload: object): Promise<T | HttpError> {
        const res = await AppContext.getApiClient().post(url, payload)
        const entity = new this.Creator(res as D)
        if (!entity.isLoaded()) {
            return newHttpError("Could not post entity", res)
        }
        return entity
    }

    async delete(url: string): Promise<T | HttpError> {
        const res = await AppContext.getApiClient().delete(url)
        const entity = new this.Creator(res as D)
        if (!entity.isLoaded()) {
            return newHttpError("Could not post entity", res)
        }
        return entity
    }



}

export default HttpClient


// WEBPACK FOOTER //
// ./src/state/helpers/HttpClient.ts